import { SourcePost } from '@sprinklr/stories/post/PostsFormatRequest';
import { Widget } from '@sprinklr/stories/widget/Widget';

export function isSmartTrends(widget: Widget) {
    return (
        (widget.postRequests?.[0].sources?.[0] as SourcePost)?.id?.reportingEngine ===
        'TRENDING_EVENT'
    );
}
